<template>
  <div @click="handleClick" :class="getClass()">
    <div class='text-container'>
      <p class='sub'>Ik wil een</p>
      <p class='main'>wijziging in het verzuim</p>
      <p class='sub'>doorgeven.</p>
    </div>
  </div>
</template>

<script>
import Compositions from '@/views/helpers/compositions';
import Modal from '@/shared/constants/modal';
import States from '@/resources/models/states';

export default {
  name: 'NewPeriodCardButton',
  props: {
    reportOfSickness: Object
  },
  computed: {
    isAnyErrors () {
      return this.isDisabledDueToSameDatePeriod ||
        this.isDisabledDueToSameDateReportOfSickness ||
        this.isDisabledPreviousIsReviewing ||
        !this.isPreviousApprovedOrReviewing ||
        this.isDisabledDueToProcessingDate;
    },
    isDisabledDueToProcessingDate () {
      return this.$store.getters.isCurrentlyProcessing;
    },
    isDisabledDueToSameDatePeriod () {
      // is there a period with startDate on today?
      return (Compositions.getLatestDateFromReportOfSickness(this.reportOfSickness) === new Date().toISOString().substr(0, 10) &&
        this.reportOfSickness.periods.length > 0 && this.reportOfSickness.recovery == null);
    },

    isDisabledDueToSameDateReportOfSickness () {
      return this.reportOfSickness.firstOfAbsence === new Date().toISOString().substr(0, 10) &&
        this.reportOfSickness.periods.length === 0 && this.reportOfSickness.recovery == null;
      // is there a reportOfSickness with firstOfAbsence on today?
    },

    isDisabledPreviousIsReviewing () {
      if (this.reportOfSickness.periods.length > 0) {
        return this.reportOfSickness.periods[this.reportOfSickness.periods.length - 1].status === States.ToReview;
      }
      return this.reportOfSickness.status === States.ToReview;
    },

    isPreviousApprovedOrReviewing () {
      if (this.reportOfSickness.periods.length > 0) {
        const period = this.reportOfSickness.periods[this.reportOfSickness.periods.length - 1];
        return period.status === States.Approved || period.status === States.Processed;
      }
      return this.reportOfSickness.status === States.Approved || this.reportOfSickness.status === States.Processed;
    }
  },
  methods: {
    handleClick () {
      if (this.isDisabledDueToSameDatePeriod) {
        this.$store.dispatch(Modal.Actions.OPEN, {
          component: 'Error',
          title: this.$t('period.modals.new-disabled-due-to-same-date-title'),
          text: this.$t('period.modals.new-disabled-due-to-same-date-text')
        });
      } else if (this.isDisabledDueToSameDateReportOfSickness) {
        this.$store.dispatch(Modal.Actions.OPEN, {
          component: 'Error',
          title: this.$t('report-of-sickness.modals.new-period-disabled-due-to-same-date-title'),
          text: this.$t('report-of-sickness.modals.new-period-disabled-due-to-same-date-text')
        });
      } else if (this.isDisabledPreviousIsReviewing) {
        this.$store.dispatch(Modal.Actions.OPEN, {
          component: 'Error',
          title: this.$t('period.modals.new-disabled-previous-is-reviewing-title'),
          text: this.$t('period.modals.new-disabled-previous-is-reviewing-text')
        });
      } else if (!this.isPreviousApprovedOrReviewing) {
        this.$store.dispatch(Modal.Actions.OPEN, {
          component: 'Error',
          title: this.$t('period.modals.new-disabled-previous-is-not-approved-or-processed-title'),
          text: this.$t('period.modals.new-disabled-previous-is-not-approved-or-processed-text')
        });
      } else if (this.isDisabledDueToProcessingDate) {
        this.$store.dispatch(Modal.Actions.OPEN, {
          component: 'Error',
          title: this.$t('period.modals.new-disabled-due-to-processing-title'),
          text: this.$t('period.modals.new-disabled-due-to-processing-text')
        });
      } else {
        this.$emit('click');
      }
    },

    getClass () {
      if (this.isAnyErrors) {
        return 'new-period-card-button disabled';
      } else {
        return 'new-period-card-button';
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.new-period-card-button {
  position: relative;
  width: 100%;
  cursor: pointer;

  border-radius: $border-radius;
  padding: 17px;
  background-color: $secondary-lighten-4;
  line-height: 1.5em;
  min-height: 150px;

  &:hover {
    background-color: lighten($secondary-lighten-4, 2%);
  }

  .text-container {
    position: absolute;
    bottom: 17px;
  }

  .sub {
    color: $secondary-darken-1;
  }
  .main {
    color: $quinary;
    font-weight: 700;
    font-size: 1.1em;
  }

  &.disabled {
    background-color: $gray-lighten-2;

    &:hover{
      background-color: lighten($gray-lighten-2, 2%);
    }

    .sub {
      color: $primary-lighten-1;
    }

    .main {
      color: $primary;
    }
  }
}
</style>
